module.exports = __webpack_public_path__ + "static/media/leader_3.5624b544.png";